import { Stack, Typography } from '@mui/material';

interface ITitle {
  name: string;
}
export const Title = ({ name }: ITitle) => {
  return (
    <Stack>
      <Typography
        variant='h5'
        component='h3'
        sx={{
          cursor: 'text',
          whiteSpace: 'nowrap',
        }}
      >
        {name}
      </Typography>
    </Stack>
  );
};
